var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-item"},[_c('div',{staticClass:"tag"},[_vm._v(_vm._s(_vm.questionType))]),_c('div',{staticClass:"q-title"},[_vm._v(_vm._s(_vm.index + 1)+"、"+_vm._s(_vm.question.question))]),_vm._l((_vm.answers),function(item,index){return _c('div',{key:index,staticClass:"anwser-item",class:{
        selected: _vm.btnStatus.type == 0 && _vm.selectedAnswer.indexOf(index) > -1,
        right:
          _vm.btnStatus.type == 1 &&
          _vm.rightAnswer.indexOf(index) > -1 &&
          _vm.selectedAnswer.indexOf(index) > -1,
        rest:
          _vm.btnStatus.type == 1 &&
          _vm.selectedAnswer.indexOf(index) < 0 &&
          _vm.rightAnswer.indexOf(index) > -1 &&
          _vm.question.type != 4,
        error:
          _vm.btnStatus.type == 1 &&
          _vm.selectedAnswer.indexOf(index) > -1 &&
          _vm.rightAnswer.indexOf(index) < 0,
      },on:{"click":function($event){return _vm.selectAnswer(index)}}},[_vm._v(" "+_vm._s(["A", "B", "C", "D"][index])+" "+_vm._s(item)+" ")])}),(_vm.selectedAnswer !== undefined)?_c('div',{staticClass:"ctrls"},[_c('button',{staticClass:"btn",on:{"click":_vm.onBtnClick}},[_vm._v(" "+_vm._s(_vm.btnStatus.type == 1 && _vm.maxLength === _vm.index + 1 ? "完成答题" : _vm.btnStatus.text)+" ")])]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }